import * as React from 'react';

import { ProductLabelModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';

import { isDiorBrand } from '@containers/ProductDetailContainer/ProductDetail/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { ITagsProps } from './model';
import { StyledLabel } from './styled';
import { useCornerTags } from './useCornerTags';

export const CornerTag: React.FC<ITagsProps> = ({
  stockAvailability,
  onClick,
  attributes,
}) => {
  const tagAttribute = useCornerTags({
    attributes: attributes as Record<string, unknown>,
  });
  const pdCtx = useProductDetailContext(false);
  const isDior = isDiorBrand(pdCtx?.product?.brand?.id);

  if (stockAvailability === IStock.outOfStock) {
    return null;
  }

  return (
    tagAttribute && (
      <StyledLabel
        key={tagAttribute.attribute}
        labelStyle={
          isDior ? ProductLabelModel.ProductStyles.neutral : tagAttribute.style
        }
        icon={tagAttribute.icon}
        labelType={ProductLabelModel.Types.corner}
        className={`pd-variant-tag-${tagAttribute.attribute}`}
        onClick={() => onClick?.(tagAttribute.attribute)}
      >
        {tagAttribute.attribute}
      </StyledLabel>
    )
  );
};
